import { processDaysOfOperation } from './functions.js';

document.addEventListener('DOMContentLoaded', processDaysOfOperation);